function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 15.5,
  r: 15.5,
  transform: "rotate(-180 16 15.5)",
  fill: "#173859"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.8248 20.7522C15.6662 20.5936 15.5771 20.3784 15.5771 20.154C15.5771 19.9296 15.6662 19.7144 15.8248 19.5557L19.4575 15.9231L15.8248 12.2904C15.6707 12.1308 15.5854 11.9171 15.5873 11.6952C15.5893 11.4734 15.6783 11.2611 15.8351 11.1042C15.992 10.9474 16.2043 10.8584 16.4261 10.8564C16.648 10.8545 16.8618 10.9398 17.0213 11.0939L21.2522 15.3248C21.4109 15.4835 21.5 15.6987 21.5 15.9231C21.5 16.1475 21.4109 16.3627 21.2522 16.5213L17.0213 20.7522C16.8627 20.9109 16.6475 21 16.4231 21C16.1987 21 15.9835 20.9109 15.8248 20.7522ZM10.7478 20.7522C10.5891 20.5936 10.5 20.3784 10.5 20.154C10.5 19.9296 10.5891 19.7144 10.7478 19.5557L14.3804 15.9231L10.7478 12.2904C10.5936 12.1308 10.5083 11.9171 10.5102 11.6952C10.5122 11.4734 10.6012 11.2611 10.7581 11.1042C10.9149 10.9473 11.1272 10.8584 11.349 10.8564C11.5709 10.8545 11.7847 10.9398 11.9443 11.0939L16.1752 15.3248C16.3338 15.4835 16.4229 15.6987 16.4229 15.9231C16.4229 16.1475 16.3338 16.3627 16.1752 16.5213L11.9443 20.7522C11.7856 20.9109 11.5704 21 11.346 21C11.1216 21 10.9064 20.9109 10.7478 20.7522Z",
  fill: "white"
});
function SvgArrowOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOpen);
export default __webpack_public_path__ + "static/media/arrowOpen.5b4d30b6c1f5bae748d7ec5cf853b729.svg";
export { ForwardRef as ReactComponent };